import "@arco-design/web-react/es/ConfigProvider/style";
import _ConfigProvider from "@arco-design/web-react/es/ConfigProvider";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import "@arco-design/web-react/es/Notification/style";
import _Notification from "@arco-design/web-react/es/Notification";
import './style/global.less';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { createStore } from 'redux';
import rootReducer from './store';
import { Provider } from 'react-redux';
import zhCN from '@arco-design/web-react/es/locale/zh-CN';
import enUS from '@arco-design/web-react/es/locale/en-US';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import axios from 'axios';
import PageLayout from './layout';
import { GlobalContext } from './context';
import Login from './pages/login';
import checkLogin from './utils/checkLogin';
import changeTheme from './utils/changeTheme';
import useStorage from './utils/useStorage';
import Register from './pages/register';
import Qs from 'query-string'; // import './mock';

const store = createStore(rootReducer);

function Index() {
  const [lang, setLang] = useStorage('arco-lang', 'zh-CN');
  const [theme, setTheme] = useStorage('arco-theme', 'light');
  const pendingRequest = new Map();

  function generateReqKey(config) {
    const {
      method,
      url,
      params,
      data
    } = config;
    return [method, url, Qs.stringify(params), Qs.stringify(data)].join('&');
  }

  function addPendingRequest(config) {
    const requestKey = generateReqKey(config); // console.log(requestKey)

    config.cancelToken = config.cancelToken || new axios.CancelToken(cancel => {
      if (!pendingRequest.has(requestKey)) {
        pendingRequest.set(requestKey, cancel);
      }
    });
  }

  function removePendingRequest(config) {
    const requestKey = generateReqKey(config);

    if (pendingRequest.has(requestKey)) {
      const cancel = pendingRequest.get(requestKey);
      cancel(requestKey);
      pendingRequest.delete(requestKey);
    }
  }

  function getArcoLocale() {
    switch (lang) {
      case 'zh-CN':
        return zhCN;

      case 'en-US':
        return enUS;

      default:
        return zhCN;
    }
  } // function fetchUserInfo() {
  //   axios({
  //     method: 'get',
  //     url: '/api/info',
  //     headers: {
  //       Authorization: 'Bearer ' + localStorage.getItem('token'),
  //     },
  //   }).then((res) => {
  //     store.dispatch({
  //       type: 'update-userInfo',
  //       payload: { userInfo: res.data },
  //     });
  //   });
  // }


  useEffect(() => {
    axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:8000' // ? 'https://www.histreams.net'
    : 'https://bwg.histreams.net'; //  : 'https://hk.histreams.net';
    // axios.defaults.headers.common['Authorization'] =
    //   'Bearer ' + localStorage.getItem('token');
    // CasdoorSDK.signin_redirect();

    axios.interceptors.request.use(function (config) {
      const {
        url
      } = config;
      console.log(url);

      if (url != '/api/token') {
        removePendingRequest(config); // 检查是否存在重复请求，若存在则取消已发的请求

        addPendingRequest(config); // 把当前请求添加到pendingRequest对象中

        return config;
      } else {
        return config;
      }
    }, error => {
      return Promise.reject(error);
    });
    axios.interceptors.response.use(data => {
      removePendingRequest(data.config);

      if (data.status && data.status == 200 && data.data.status == 'error') {
        return;
      }

      if (data.data.status && data.data.status !== 200) {
        const id = `${Date.now()}`;

        _Notification.error({
          id,
          title: 'Error',
          content: data.data.msg,
          duration: 0,
          btn: /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(_Button, {
            type: "primary",
            size: "small",
            target: "_blank",
            href: "https://card.histreams.net/",
            onClick: () => _Notification.remove(id)
          }, "\u6350\u8D60"))
        });
      }

      return data;
    }, err => {
      removePendingRequest(err.config || {});
      console.log(err);

      if (err.response.status == 451) {
        _Notification.error({
          title: 'Error',
          content: 'Error 451: Unavailable Due to Legal Reasons'
        });
      }

      if (err.response.status == 401) {
        // window.location.search = 're=' + window.location.href;
        console.log(err.response);

        if (err.response.config.url.includes('f1tv.formula1.com')) {
          _Notification.error({
            title: 'Error',
            content: err.response.data.message
          });
        } else if (err.response.config.url.includes('star.playback.edge.bamgrid.com')) {
          return Promise.reject(err.response);
        } else if (err.response.config.url.includes('star.content.edge.bamgrid.com')) {
          return Promise.reject(err.response);
        } else {
          if (!window.location.href.includes('/login')) {
            localStorage.setItem('redirectUrl', window.location.href);
            console.log(err.response);

            if (err.response.config.url.includes('login/refresh')) {} else {
              fetchRefreshToken();
            }
          }
        }
      }

      return Promise.resolve(err);
    });
    const p = window.location.pathname.replace(/\//g, '');

    if (checkLogin()) {// fetchUserInfo();
    } else if (p == 'register') {} else if (p == 'soccer') {} else if (p == 'home') {} else if (p == 'reset') {} else if (p !== 'login') {
      window.location.pathname = '/login';
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);

  function fetchRefreshToken() {
    axios({
      method: 'post',
      url: '/api/login/refresh',
      data: {
        refresh_token: localStorage.getItem('refresh_token')
      },
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    }).then(res => {
      console.log(res);

      if (res.request.status == 401) {
        window.location.href = '/login';
      } else {
        localStorage.setItem('token', res.data.access_token);
        window.location.href = localStorage.getItem('redirectUrl');
      }
    });
  }

  useEffect(() => {
    changeTheme(theme);
  }, [theme]);
  const contextValue = {
    lang,
    setLang,
    theme,
    setTheme
  };
  return /*#__PURE__*/React.createElement(BrowserRouter, null, /*#__PURE__*/React.createElement(_ConfigProvider, {
    locale: getArcoLocale(),
    componentConfig: {
      Card: {
        bordered: false
      },
      List: {
        bordered: false
      },
      Table: {
        border: false
      }
    }
  }, /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(GlobalContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: "/register",
    component: Register
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/login",
    component: Login
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/",
    component: PageLayout
  }))))));
}

ReactDOM.render( /*#__PURE__*/React.createElement(Index, null), document.getElementById('root'));